import { render, staticRenderFns } from "./studentifno-editstudent.vue?vue&type=template&id=1b7be402&scoped=true"
import script from "./studentifno-editstudent.vue?vue&type=script&lang=js"
export * from "./studentifno-editstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7be402",
  null
  
)

export default component.exports